import axios from "axios";

// 1. Hàm lấy Base URL từ window.APP_CONFIG
const getBaseUrl = () => {
  return window.APP_CONFIG?.API_BASE_URL || "http://localhost:7217";
};

const BASE = getBaseUrl();

// 2. Tạo axios client với baseURL động
const axiosClient = axios.create({
  baseURL: `${BASE}/api`, 
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor cho Request: Thêm Token vào Header
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor cho Response: Xử lý lỗi 401 (Hết hạn session)
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Chỉ xử lý đá về Login nếu gặp lỗi 401
    if (error.response?.status === 401) {
      // KIỂM TRA: Nếu không phải đang ở trang Login thì mới thực hiện đá
      if (!window.location.pathname.includes("/login")) {
        console.warn("Session expired. Redirecting to login...");
        
        // Xóa sạch cả Token và User để App.js nhận diện đúng trạng thái đã logout
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        // Quay về trang login
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosClient;